//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { required } from 'vuelidate/lib/validators';
import form from '~/mixins/components/form';

export default {
  name: 'booking-direction-form',
  mixins: [form],
  props: {
    routeLocked: {
      type: Boolean,
      default: false,
    },
    submitLabel: {
      type: String,
      default: '',
    },
    pending: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      airport: null,
      localeKey: 'booking.direction',
    };
  },
  validations () {
    return {
      request: {
        departure: { required },
        arrival: { required },
        ...(!this.isCabinet && {
          dateBegin: { required },
          dateFinish: { required },
        }),
        ...(this.isCabinet && { date: { required } }),
      },
    };
  },
};
